import { useLocation, Link } from 'react-router-dom';
import {NavLink} from "react-router";

function SmartLink({ to, children }) {
    const location = useLocation();

    const handleClick = (e) => {
        if (location.pathname === to) {
            e.preventDefault(); // Cancel navigation
            console.log('Already on this page.');
        }
    };

    return (
        <NavLink to={to} onClick={handleClick}>
            {children}
        </NavLink>
    );
}


export default SmartLink;``
